import { DefaultApi } from '@engelvoelkersamericas/api';

export const apiClient = new DefaultApi(
  undefined,
  process.env.NEXT_PUBLIC_DIGITAL_EXPERIENCE_API_V2_URL!,
);
